module.exports = __webpack_public_path__ + "img/SaveButton.948fdd21.svg";